<div [class.ks-dialog]="isDialog" class="ks-document-viewer ks-card">
  <header *ngIf="isDialog" class="ks-card-header">
    <div class="ks-card-header__title">
      <h3 class="ks-h3 ks-text-semi-light-neutral ks-mb-0">
        Document <span class="ks-font-size-md">preview</span>
      </h3>
    </div>
    <div class="ks-card-header__tools">
      <button
        type="button"
        ktTooltip="Close"
        class="ks-btn-xs ks-btn-icon-round ks-btn-flat-neutral"
        (click)="close()"
      >
        <span inlineSVG="assets/icons/Close.svg"></span>
      </button>
    </div>
  </header>
  <main class="ks-card-body">
    <div *ngIf="isDialog" class="ks-document-viewer-tools">
      <div *ngIf="count > 1">
        <button
          type="button"
          ktTooltip="Prev"
          class="ks-btn-sm ks-btn-icon-round ks-btn-flat-neutral"
          [disabled]="pageIdx === 0"
          (click)="togglePage('PREV')"
        >
          <span inlineSVG="assets/icons/Chevron-left.svg"></span>
        </button>
        <button
          type="button"
          ktTooltip="Next"
          class="ks-btn-sm ks-btn-icon-round ks-btn-flat-neutral"
          [disabled]="pageIdx === count - 1"
          (click)="togglePage('NEXT')"
        >
          <span inlineSVG="assets/icons/Chevron-right.svg"></span>
        </button>
      </div>
      <div>
        <button
          type="button"
          ktTooltip="Zoom in"
          class="ks-btn-sm ks-btn-icon-round ks-btn-flat-neutral"
          (click)="zoom('IN')"
        >
          <span inlineSVG="assets/icons/Zoom-in.svg"></span>
        </button>
        <button
          type="button"
          ktTooltip="Zoom fit"
          class="ks-btn-sm ks-btn-icon-round ks-btn-flat-neutral"
          (click)="zoom('FIT')"
        >
          <span inlineSVG="assets/icons/Zoom-fit.svg"></span>
        </button>
        <button
          type="button"
          ktTooltip="Zoom out"
          class="ks-btn-sm ks-btn-icon-round ks-btn-flat-neutral"
          (click)="zoom('OUT')"
        >
          <span inlineSVG="assets/icons/Zoom-out.svg"></span>
        </button>
      </div>
    </div>
    <ng-container [ngSwitch]="type">
      <div *ngSwitchCase="DocumentType.IMG" class="img-viewer">
        <ng-container *ngIf="loading$ | async; else image">
          <span
            inlineSVG="assets/icons/Image-placeholder.svg"
            class="img-placeholder loading"
          ></span>
        </ng-container>
        <ng-template #image>
          <img
            *ngIf="count; else imgPlaceholder"
            [src]="pages[pageIdx]"
            [alt]="getDocumentName()"
            [style.width]="zoomScale * 100 + '%'"
          />
          <ng-template #imgPlaceholder>
            <span inlineSVG="assets/icons/Image-placeholder.svg" class="img-placeholder"></span>
          </ng-template>
        </ng-template>
      </div>
      <pdf-viewer
        *ngSwitchCase="DocumentType.PDF"
        [src]="url"
        [page]="pageIdx + 1"
        [zoom]="zoomScale * (isDialog ? 0.9 : 0.3)"
        (after-load-complete)="count = $event.numPages"
      ></pdf-viewer>
    </ng-container>
  </main>
</div>
